var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
import { PacemWidgetElement, EXPRESSION_WIDGET_METADATA_EXTRA } from '../types';
import { EXPRESSION_METADATA_TYPE } from '../../scaffolding/types';
import { PacemWidgetDataElement } from './data';
import { PacemWidgetFetchElement } from './fetcher';
//namespace Pacem.Components.Cms {
export const FETCH_CREDENTIALS_METADATA = {
    prop: 'fetchCredentials', type: 'string', dataType: 'enumeration', display: { name: 'Fetch Credentials' }, extra: {
        enum: ['same-origin', 'omit', 'include']
    }
};
export const ACCESS_TOKEN_METADATA = {
    prop: 'accessToken', type: EXPRESSION_METADATA_TYPE, display: { name: 'Access Token' },
    extra: Utils.extend({}, EXPRESSION_WIDGET_METADATA_EXTRA, { filter: (e) => e instanceof PacemWidgetDataElement || e instanceof PacemWidgetFetchElement })
};
export class PacemBearerWidgetElement extends PacemWidgetElement {
    constructor() {
        super(...arguments);
        this.fetchCredentials = 'same-origin';
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'accessToken') {
            if (!Utils.isNullOrEmpty(val)) {
                this.fetchHeaders = { 'Authorization': 'Bearer ' + val };
            }
            else {
                this.fetchHeaders = {};
            }
        }
    }
}
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.String })
], PacemBearerWidgetElement.prototype, "fetchCredentials", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemBearerWidgetElement.prototype, "fetchHeaders", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.String })
], PacemBearerWidgetElement.prototype, "accessToken", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemBearerWidgetElement.prototype, "fetching", void 0);
